module.exports = __webpack_public_path__ + "static/qyiana-bfd626d5bd51159b8cca4887e2653de3.png";